import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const prometheus = defineConnector({
  identifier: "prometheus",
  name: "Prometheus",
  tagLine: "Monitoring and alerting",
  keywords: "promql metrics time series tsdb scrape exporter targets rules",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Configure your Prometheus endpoint",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the URL of your Prometheus server. If your Prometheus instance requires authentication, provide the credentials below.",
        },
      ],
    },
    {
      title: "Enter your Prometheus details",
      items: [
        {
          kind: "baseUrl",
          label: "Prometheus URL",
          required: true,
          placeholder: "https://prometheus.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Prometheus server.",
        },
        {
          kind: "input",
          label: "Username (optional)",
          required: false,
          target: { kind: "configuration", field: "username" },
          helperText: "For basic auth protected instances.",
        },
        {
          kind: "input",
          label: "Password (optional)",
          required: false,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/status/buildinfo`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    PROMETHEUS_URL: baseUrl || "",
  }),
});
